interface Props { label: string; value: string|number; sub?: string; color?: string; icon?: string; }

export default function StatCard({ label, value, sub, color="text-emerald-600", icon }: Props) {
  return (
    <div className="bg-slate-50 border border-slate-200 rounded-xl p-4">
      <div className="flex justify-between items-start">
        <p className="text-xs text-slate-500">{label}</p>
        {icon && <span className="text-lg">{icon}</span>}
      </div>
      {/* <p className={`text-2xl font-medium mt-1.5 mb-0.5 ${color}`}>{value}</p> */}
      <p className={`text-l md:text-2xl font-medium mt-1 mb-1.5 md:mt-1.5 md:mb-0.5 ${color}`}>{value}</p>
      {sub && <p className="text-xs text-slate-400">{sub}</p>}
    </div>
  );
}
